var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 124.87 96.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}.cls-1{fill:url(#Degradado_sin_nombre_10);}.cls-2{fill:url(#Degradado_sin_nombre_9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_10",
    x1: -694.1,
    y1: 4317.47,
    x2: -693.93,
    y2: 4317.29,
    gradientTransform: "matrix(721.09, 0, 0, -482.94, 500513.72, 2085064.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbced0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84838b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    x1: -693.95,
    y1: 4319.03,
    x2: -693.78,
    y2: 4318.85,
    gradientTransform: "matrix(398, 0, 0, -406.12, 276239.18, 1754091.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165caa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.43,83.63C28,83.63,0,64.91,0,41.81S28,0,62.43,0s62.44,18.72,62.44,41.81S96.92,83.63,62.43,83.63ZM72,16.35c-26.21,0-47.45,12.8-47.45,28.58S45.78,73.52,72,73.52s45.55-8.75,45.55-28.59S98.2,16.35,72,16.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.08,64.76a47.31,47.31,0,0,1,6,2.25,11.72,11.72,0,0,1,3,2.17,8.13,8.13,0,0,1,1.38,2l14.9,25.11H96.3L85,75.15s-2.3-4-3.72-5.1c-1.19-1-1.69-1.3-2.86-1.3H72.74V96.28H51.45V26H94.22s19.48.36,19.48,18.89S95.08,64.76,95.08,64.76ZM85.82,41.22H72.93v12h12.9s6,0,6-6.08S85.82,41.22,85.82,41.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.d7a70622bf2d882a84b11889c05c66d0.svg";
export { ForwardRef as ReactComponent };